import { render, staticRenderFns } from "./RatingsWidget.vue?vue&type=template&id=d15fd61c&scoped=true&lang=pug&"
import script from "./RatingsWidget.vue?vue&type=script&lang=ts&"
export * from "./RatingsWidget.vue?vue&type=script&lang=ts&"
import style0 from "./RatingsWidget.vue?vue&type=style&index=0&id=d15fd61c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15fd61c",
  null
  
)

export default component.exports